import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

(function () {

  if (
    !document.body.classList.contains('area-map-page')
  ) return this;


  const modal_slide_container = document.querySelectorAll('.modal-post__slide');
  let slide_container = document.querySelectorAll('.facility-slider');

  modal_slide_container.forEach((target, i) => {
    var big_slider = tns({
      autoplay: true,
      autoplayButtonOutput: false,
      loop: true,
    	container: target,
    	navContainer: false,
    	items: 1,
    	mouseDrag: true,
      controls: false,
      nav: false,
      mode: 'gallery',
      slideBy: 'page',
      speed: 3000,
    });
  });

  slide_container.forEach((target, i) => {

    // console.log('hello area-map-page');
    const main = target.querySelector('.facility-slider__main');
    const thumb = target.querySelector('.facility-slider__thumb');

    var big_slider = tns({
      autoplay: true,
      autoplayButtonOutput: false,
    	loop: true,
    	container: main,
    	navContainer: thumb ? thumb : false,
    	items: 1,
      navAsThumbnails: true,
    	mouseDrag: true,
      controls: false,
      navPosition: 'bottom',
      slideBy: 'page',
      speed: 1000,
    });

    if(!thumb) return;

    var small_slider = tns({
    	loop: false,
    	container: thumb,
    	items: 5,
    	mouseDrag: false,
    	nav: false,
    	controls: false,
    	axis: "vertical"
    });

  });

})();
